import { render, staticRenderFns } from "./chatrecordcheck.vue?vue&type=template&id=496a18d5&scoped=true&"
import script from "./chatrecordcheck.vue?vue&type=script&lang=ts&"
export * from "./chatrecordcheck.vue?vue&type=script&lang=ts&"
import style0 from "./chatrecordcheck.vue?vue&type=style&index=0&id=496a18d5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "496a18d5",
  null
  
)

export default component.exports